<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/pay/prepaid' }">待支付项目</el-breadcrumb-item>
            <el-breadcrumb-item>合并付款</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="order-wrapper">
            <div class="order-info">
                <div class="header">
                    <div class="title">
                        付款多笔
                    </div>
                    <div
                        class="bar"
                        style="font-size: 14px;"
                    >
                        订单合计： <span class="text-danger">{{ info.to_pay }}</span>
                    </div>
                </div>
                <div class="body">
                    <div class="table-box">
                        <el-table
                            :data="[info]"
                        >
                            <el-table-column
                                align="center"
                                prop="count"
                                label="付款笔数"
                            />
                            <el-table-column
                                align="center"
                                prop="money"
                                label="服务金额小计"
                            />
                            <el-table-column
                                align="center"
                                prop="service_fee"
                                label="平台服务费小计"
                            />
                            <el-table-column
                                align="center"
                                prop="to_pay"
                                label="合计"
                            />
                        </el-table>
                    </div>
                </div>
            </div>
            <div class="pay-box">
                <div class="header">
                    <div class="title">
                        余额支付
                    </div>
                    <div class="bar">
                        支付： <span class="text-danger">{{ info.to_pay }}</span>
                    </div>
                </div>
                <div class="body">
                    <el-form
                        size="small"
                        label-width="150px"
                        style="width: 320px; margin-top: 20px"
                    >
                        <el-form-item label="账户余额：">
                            {{ use_money }}元
                        </el-form-item>
                        <el-form-item label="支付密码：">
                            <el-input
                                v-model="formItem.pay_password"
                                type="password"
                                placeholder="请输入支付密码"
                            />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrapper">
                <el-button
                    type="primary"
                    class="btn-standard"
                    @click="queryPay"
                >
                    确认支付
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
export default {
    name: 'packPay',
    data () {
        return {
            info: {},
            use_money: 0.00,
            formItem: {
                pay_password: ''
            }
        }
    },
    vuerify: {
        'formItem.pay_password': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入支付密码'
            },
            {
                test: /^[a-zA-Z0-9_-]{6,18}$/,
                message: '支付密码由6-18位的数字、字母和_组成'
            }
        ]
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    mounted () {
        if (localStorage.getItem('PACKPAY')) {
            this.getUseMoney()
            console.log(localStorage.getItem('PACKPAY'))
            this.info = JSON.parse(localStorage.getItem('PACKPAY'))
        } else {
            this.$message.error('获取合并支付信息失败，请重试。')
        }
    },
    methods: {
        queryPay () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/project/newbatchpay', qs.stringify({
                    lists: JSON.stringify(this.info.lists),
                    money: this.info.to_pay,
                    pay_password: this.formItem.pay_password
                }))
                    .then(res => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '支付成功。'
                            })
                            localStorage.removeItem('PACKPAY')
                            router.replace('/index/pay/prepaid')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        },
        getUseMoney () {
            this.$http.get('/api/user/account/capital')
                .then(res => {
                    if (res.code === 0) {
                        this.use_money = res.data.use_money
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";

    .order-wrapper {
        background-color: #FFF;
        margin-top: 20px;
        padding-top: 20px;
    }

    .btn-wrapper {
        padding: 0 36px 40px 0;
        display: flex;
        flex-direction: row-reverse;
    }

    .order-info, .pay-box {
        border: 1px solid $--color-border-base;
        margin: 20px;
        margin-top: 0;
        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 18px 24px 12px;

            border-bottom: 1px solid $--color-border-base;

            .title {
                font-size: 14px;
                font-weight: 700;
            }

            .bar {
                display: flex;
                align-items: center;
                font-weight: 500;
                font-size: 14px;

                .text__error {
                    font-size: 24px;
                    font-family: Arial, sans-serif;
                }
            }
        }
    }

    .pay-box {
        .header {
            .bar {
                .text__error {
                    font-size: 18px;
                    font-family: Arial, sans-serif;
                }
            }
        }
    }
</style>
